import { Button } from 'common/components/Button/Button'
import { BUTTON_PROPORTION } from 'common/constants/buttonConstants'
import { formatMoney } from 'common/services/format'

import SuccessIcon from '../assets/success.svg?react'

import styles from './success-view.module.scss'

type Props = {
  amount: number
  terminalLabel: string
  onDone: () => void
}

export const SuccessView = ({ amount, terminalLabel, onDone }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <SuccessIcon width={72} height={72} />
      </div>
      <div className={styles.textGroup}>
        <h3 className={styles.title}>Payment successful</h3>
        <p className={styles.subtitle}>
          {formatMoney(amount)} charged on
          {terminalLabel && <span className={styles.terminalName}>{terminalLabel}</span>}
        </p>
      </div>
      <div className={styles.footer}>
        <Button proportion={BUTTON_PROPORTION.LARGE} onClick={onDone} className={styles.doneButton}>
          Done
        </Button>
      </div>
    </div>
  )
}
